<h1 mat-dialog-title>{{ 'common.reasonChange' | translate }}</h1>

<div mat-dialog-content class="qualificates-theme" >

  <div fxLayout="row" class="flexwrap">

    <div fxFlex="100">
      <textarea rows="5" matAutosizeMinRows="5" matInput placeholder="{{ 'common.reasonChange' | translate }}"
        [(ngModel)]="data.reason" name="reason" required style="resize: none;"></textarea>
    </div>

  </div>

</div>

<div mat-dialog-actions align="end" class="qualificates-theme">
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>